import module from './module.js'

import './components/component.js'
import './components/escenario/component.js'
import './components/escenario/calculo/component.js'
import './components/escenario/calculo/calcular/component.js'
import './components/escenario/conceptos/component.js'
import './components/escenario/conceptos/agregar/component.js'
import './components/escenario/conceptos/concepto/component.js'
import './components/escenario/configuracion/component.js'
import './components/escenario/documentos/component.js'
import './components/escenario/documentos/cotizacion/component.js'
import './components/escenario/documentos/finiquito/component.js'
import './components/escenario/documentos/renuncia/component.js'
import './components/escenarios/component.js'
import './components/escenarios/agregar/component.js'
import './components/escenarios/aplicar/component.js'
import './components/escenarios/eliminar/component.js'
import './components/escenarios/item/component.js'
import './components/nomina/eliminar/component.js'
import './routes/finiquito.js'
import './routes/finiquito/escenario.js'
import './routes/finiquito/escenarios.js'
import './routes/finiquito/escenario/calculo.js'
import './routes/finiquito/escenario/documentos.js'
import './services/Finiquito.js'
import './services/Finiquito/Escenario.js'
import './services/Finiquito/Escenarios.js'
import './services/Finiquito/Idnomina.js'
import './services/Finiquito/Escenario/Documentos.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/finiquito/index.js